import { render, staticRenderFns } from "./141.vue?vue&type=template&id=00063908&scoped=true&"
var script = {}
import style0 from "./141.vue?vue&type=style&index=0&id=00063908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00063908",
  null
  
)

export default component.exports